import React, { useState, useEffect } from 'react';

import AudioPlayer from '../../../AudioPlayer';
import notificationSound from '@extras/notification-sound.mp3';

const { Status: AudioStatus } = AudioPlayer;

interface INotificationSound {
  volume: number;
  isNotificationsSoundEnabled: boolean;
  notificationsCount: number;
}

export const NotificationSound = ({
  volume,
  isNotificationsSoundEnabled,
  notificationsCount,
}: INotificationSound) => {
  const [soundStatus, setSoundStatus] = useState(AudioStatus.STOPPED);

  useEffect(() => {
    if (notificationsCount > 0 && isNotificationsSoundEnabled) {
      setSoundStatus(AudioStatus.PLAYING);
    } else {
      setSoundStatus(AudioStatus.STOPPED);
    }
  }, [notificationsCount, isNotificationsSoundEnabled]);

  const onFinishedPlaying = () => {
    setSoundStatus(AudioStatus.STOPPED);
  };

  return (
    <AudioPlayer
      autoLoad
      volume={volume}
      playStatus={soundStatus}
      url={notificationSound}
      onFinishedPlaying={onFinishedPlaying}
    />
  );
};
